import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { InventaireService } from '../services/inventaire.service';

export const inventaireSessionGuard: CanActivateFn = () => {
  const inventaire = inject(InventaireService);
  const router = inject(Router);

  if (inventaire.currentSession) {
    return true;
  }
  return router.createUrlTree(['/qr-scan']);
};
